import 'react-toastify/dist/ReactToastify.css'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import ErrorBoundary from '../../../../../shared/components/errorBoundary/ErrorBoundary'
import { transactionProxy, TransactionTab } from '../../../../../shared/proxies/transactionProxy'
import { PaymentDetailsTab } from './PaymentDetailsTab'
import { TechnicalsDetailsTab } from './TechnicalDetailsTab'

export const handleTabChange = (selectedTab: string) => () => {
  transactionProxy.selectedTab = selectedTab
}

export function TransactionMainSection (): ReactElement {
  const snap = useSnapshot(transactionProxy)
  const { siteTheme: { customerNavTabs } } = useSnapshot(proxyGlobalAuth)
  return (
    <div className="bg-white shadow rounded py-4 mb-8 px-4 mr-4 w-3/5">
      <PlaceholderBox loading={snap.apiCall.loading} rows={40} rowHeight="h-5">
        <ErrorBox error={snap.apiCall.error} />
        <div className="pb-4 flex justify-between">

          <div>

            <div className=" border-b border-gray-200">
              <nav className=" flex space-x-8" aria-label="Tabs">
                <button
                  onClick={handleTabChange(TransactionTab.PaymentDetails)}
                  className={cn(
                    snap.selectedTab === TransactionTab.PaymentDetails
                      ? customerNavTabs.activeClasses
                      : customerNavTabs.inactiveClasses,
                    'whitespace-nowrap px-1 border-b-2 font-medium text-xl'
                  )}
                >
                  Payment Details
                </button>

                <button
                  onClick={handleTabChange(TransactionTab.TechnicalDetails)}
                  className={cn(
                    snap.selectedTab === TransactionTab.TechnicalDetails
                      ? customerNavTabs.activeClasses
                      : customerNavTabs.inactiveClasses,
                    'whitespace-nowrap px-1 border-b-2 font-medium text-xl'
                  )}
                >
                  Technical Details
                </button>

              </nav>
            </div>

          </div>
        </div>
        {snap.selectedTab === TransactionTab.PaymentDetails ? <ErrorBoundary><PaymentDetailsTab /></ErrorBoundary> : <div />}
        {snap.selectedTab === TransactionTab.TechnicalDetails ? <ErrorBoundary><TechnicalsDetailsTab /></ErrorBoundary> : <div />}

      </PlaceholderBox>
    </div>
  )
}
